interface CheckboxCircleProps {
    className?: string;
    checked?: boolean;
    handleClick?: () => void;
}

const CheckboxCircle: React.FC<CheckboxCircleProps> = ({
    className = '',
    checked = false,
    handleClick,
}) => {
    return (
        <svg
            className={className}
            onClick={handleClick}
            width="1.2em"
            height="1.2em"
            viewBox="0 0 13 13"
            xmlns="http://www.w3.org/2000/svg"
        >
            {!checked ? (
                <path d="M6.5 11.917a5.417 5.417 0 110-10.833 5.417 5.417 0 010 10.833zm0-1.084a4.333 4.333 0 100-8.667 4.333 4.333 0 000 8.667z" />
            ) : (
                <path d="M6.5 11.917a5.417 5.417 0 110-10.833 5.417 5.417 0 010 10.833zm0-1.084a4.333 4.333 0 100-8.667 4.333 4.333 0 000 8.667zm-.54-2.166L3.662 6.368l.766-.766L5.96 7.136 9.024 4.07l.766.766-3.83 3.83z" />
            )}
        </svg>
    );
};
export default CheckboxCircle;
